import { isTeamInviteToken } from "./team-invite-pending";

export type AppRoute =
  | "auth"
  | "account"
  | "teams"
  | "team-invite"
  | "admin"
  | "recovery"
  | "device"
  | "payment-complete"
  | "squad-tactical-planner"
  | "contact"
  | "not-found";

export function extractTeamInviteToken(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  const match = /^\/join\/team\/([^/]+)$/.exec(path);
  return match && isTeamInviteToken(match[1]!) ? match[1]! : null;
}

/**
 * Resolve exactly the browser pathname consumed by App. Query strings and
 * fragments deliberately remain outside this function, just as they are when
 * App reads window.location.pathname.
 */
export function resolveAppRoute(pathname: string): AppRoute {
  const path = pathname.replace(/\/+$/, "") || "/";
  switch (path) {
    case "/":
      return "auth";
    case "/account":
      return "account";
    case "/account/teams":
      return "teams";
    case "/admin":
      return "admin";
    case "/recover":
    case "/recover/reset":
      return "recovery";
    case "/device":
      return "device";
    case "/pay/done":
      return "payment-complete";
    case "/products/squad-tactical-planner":
      return "squad-tactical-planner";
    case "/contact":
      return "contact";
    default:
      return extractTeamInviteToken(path)
        ? "team-invite"
        : "not-found";
  }
}
